import { Modal } from "pepsico-ds";
import PropTypes from "prop-types";

/**
 * Component that renders confirmation and discard modals for configuration pages
 */
export const ConfigurationModals = ({
  confirmationModalOpen,
  discardModalOpen,
  setConfirmationModalOpen,
  setDiscardModalOpen,
  isLoading,
  handleSaveConfirmation,
  navigateToSystemSettings,
  configType = "configuration",
}) => {
  return (
    <>
      {/* Save Confirmation Modal */}
      <Modal
        showModal={confirmationModalOpen}
        onCloseModal={() => setConfirmationModalOpen(false)}
        primaryButtonProps={{
          size: "medium",
          text: "Save",
          variant: "primary",
          disabled: isLoading,
          onClick: handleSaveConfirmation,
        }}
        secondaryButtonProps={{
          size: "medium",
          text: "Back to Program Settings",
          variant: "secondary",
          onClick: () => setConfirmationModalOpen(false),
        }}
        showTertiaryButton={false}
        showLink={false}
      >
        <div className="wrap">
          <h2>Save this settings?</h2>
          <p>Are you sure you want to update the {configType}?</p>
        </div>
      </Modal>

      {/* Discard Modal */}
      <Modal
        showModal={discardModalOpen}
        onCloseModal={() => setDiscardModalOpen(false)}
        primaryButtonProps={{
          size: "medium",
          text: "Discard",
          variant: "primary",
          disabled: isLoading,
          onClick: navigateToSystemSettings,
        }}
        secondaryButtonProps={{
          size: "medium",
          text: "Back to edit page",
          variant: "secondary",
          onClick: () => setDiscardModalOpen(false),
        }}
        showTertiaryButton={false}
        showLink={false}
      >
        <div className="wrap">
          <h2>Discard changes?</h2>
          <p>Are you sure you want to discard the changes?</p>
        </div>
      </Modal>
    </>
  );
};

ConfigurationModals.propTypes = {
  confirmationModalOpen: PropTypes.bool.isRequired,
  discardModalOpen: PropTypes.bool.isRequired,
  setConfirmationModalOpen: PropTypes.func.isRequired,
  setDiscardModalOpen: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  handleSaveConfirmation: PropTypes.func.isRequired,
  navigateToSystemSettings: PropTypes.func.isRequired,
  configType: PropTypes.string,
};

export default ConfigurationModals;
